import { createReducer } from '@reduxjs/toolkit';
import { NotificationsState } from '../types/notifications';
import { logout } from '../types';
import {
  setUnreadCount,
  clearNotifications,
  fetchNotifications,
  fetchUnreadCount,
  markAsRead,
  markAllAsRead,
  deleteNotification,
} from '../actions/notifications';

const initialState: NotificationsState = {
  notifications: [],
  unreadCount: 0,
  isLoading: false,
  currentPage: 1,
  totalCount: 0,
};

export const notificationsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setUnreadCount, (state, action) => {
      state.unreadCount = action.payload;
    })
    .addCase(clearNotifications, (state) => {
      state.notifications = [];
      state.unreadCount = 0;
      state.currentPage = 1;
      state.totalCount = 0;
    })
    // fetchNotifications
    .addCase(fetchNotifications.pending, (state) => {
      state.isLoading = true;
    })
    .addCase(fetchNotifications.fulfilled, (state, action) => {
      const { data, count, page } = action.payload;
      if (page === 1) {
        state.notifications = data;
      } else {
        state.notifications = [...state.notifications, ...data];
      }
      state.totalCount = count;
      state.currentPage = page;
      state.isLoading = false;
    })
    .addCase(fetchNotifications.rejected, (state) => {
      state.isLoading = false;
    })
    // fetchUnreadCount
    .addCase(fetchUnreadCount.fulfilled, (state, action) => {
      state.unreadCount = action.payload;
    })
    // markAsRead
    .addCase(markAsRead.fulfilled, (state, action) => {
      const id = action.payload;
      const notification = state.notifications.find((n) => n.id === id);
      if (notification && !notification.is_read) {
        notification.is_read = true;
        notification.read_at = new Date().toISOString();
        state.unreadCount = Math.max(0, state.unreadCount - 1);
      }
    })
    // markAllAsRead
    .addCase(markAllAsRead.fulfilled, (state) => {
      state.notifications.forEach((n) => {
        if (!n.is_read) {
          n.is_read = true;
          n.read_at = new Date().toISOString();
        }
      });
      state.unreadCount = 0;
    })
    // deleteNotification
    .addCase(deleteNotification.fulfilled, (state, action) => {
      const id = action.payload;
      const notification = state.notifications.find((n) => n.id === id);
      if (notification && !notification.is_read) {
        state.unreadCount = Math.max(0, state.unreadCount - 1);
      }
      state.notifications = state.notifications.filter((n) => n.id !== id);
      state.totalCount = Math.max(0, state.totalCount - 1);
    })
    // logout
    .addCase(logout, () => initialState);
});
